import Marquee from "react-fast-marquee";

const WORDS = [
  "Music Photography",
  "Cinematic Video",
  "Full-Scale Film",
  "Recording Studio",
  "Brand Rollouts",
  "Album Covers",
  "Press Kits",
  "Short Films",
  "Live Performance",
];

export default function KineticMarquee() {
  return (
    <section
      data-testid="kinetic-marquee"
      className="relative bg-[#050505] border-y border-white/10 py-6 md:py-8 overflow-hidden"
    >
      <Marquee gradient={false} speed={40} pauseOnHover={false} autoFill>
        {WORDS.map((w, idx) => (
          <span key={`${w}-${idx}`} className="flex items-center mx-8 md:mx-14">
            <span className="font-display uppercase text-3xl md:text-5xl text-white/90 tracking-tight">
              {w}
            </span>
            <span className="mx-8 md:mx-14 text-[#E50914] font-display text-3xl md:text-5xl">
              ✦
            </span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
